module.exports = __webpack_public_path__ + "media/images/chevron-up-68336064.svg";